export let hres62eColumns = () => {
  let indexColumns = [
    {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES62EC1',
      labelIndex: '10',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'seqno',
      name: '',
      labelCodapp: 'HRES62EC1',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'numlereq',
      name: '',
      labelCodapp: 'HRES62EC1',
      labelIndex: '90',
      class: 'align-center',
      style: 'min-width: 120px;'
    }, {
      key: 'desc_codleave',
      name: '',
      labelCodapp: 'HRES62EC1',
      labelIndex: '30',
      style: 'min-width: 150px;'
    }, {
      key: 'dtetimperiod',
      name: '',
      labelCodapp: 'HRES62EC1',
      labelIndex: '40',
      style: 'min-width: 400px;',
      headerRow: 1,
      colspan: 4,
      rowspan: 1
    }, {
      key: 'dtestrt',
      name: '',
      labelCodapp: 'HRES62EC2',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      dataType: 'date'
    }, {
      key: 'dteend',
      name: '',
      labelCodapp: 'HRES62EC2',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      dataType: 'date'
    }, {
      key: 'timstrt',
      name: '',
      labelCodapp: 'HRES62EC2',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'timend',
      name: '',
      labelCodapp: 'HRES62EC2',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES62EC1',
      labelIndex: '50',
      style: 'min-width: 200px;'
    }, {
      key: 'remarkap',
      name: '',
      labelCodapp: 'HRES62EC1',
      labelIndex: '60',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRES62EC1',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRES62EC1',
      labelIndex: '80',
      style: 'min-width: 200px;'
    }
  ]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}

export let hres62eMaxRowspan = {
  index: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres62e.js